import {parseErrorDetails, statusFromResponse} from 'gen-ts-googleapis';

export const getGrpcErrorDetails = (error: any) => {
  const metaData = error.metadata;
  const grpcStatus = metaData?.get('grpc-status')[0];
  if (grpcStatus !== undefined && grpcStatus !== '0') {
    const resStatus = statusFromResponse({
      headers: metaData,
      status: error.status,
      message: error.message,
      statusMessage: 'TEST',
      trailers: metaData,
    });
    return resStatus ? parseErrorDetails(resStatus) : [];
  }

  return undefined;
};
